import CustomTabs from "../../Common/tab/CustomTabs";
import PageTitle from "../../Misc/PageTitle";
import Login from "../Login";
import SignUp from "../SignUp";

export default function LoginSignUpWrapper({ baseURL, clientID, AppDisplayName, appSettings, activeTab, setActiveTab }) {
    const tabs = [
        { label: "Login", value: "0" },
        { label: "Sign up", value: "1" },
    ];

    return (
        <>
            <PageTitle hideBackButton={false} name={""} className="d-flex flex-column align-items-center justify-content-center">
                <CustomTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
            </PageTitle>
            {activeTab === "0" ? (
                <Login baseURL={baseURL} clientID={clientID} AppDisplayName={AppDisplayName} appSettings={appSettings}/>
            ) : (
                <SignUp baseURL={baseURL} clientID={clientID} AppDisplayName={AppDisplayName} appSettings={appSettings} setActiveTab={setActiveTab} />
            )}
        </>
    );
}
